//Comentario necesario para codificación en UTF-8, ver Inc6743
(function() {
	var App = angular.module('pphhApp');

	App.service("ageSendaSyncActionController", ["$mdDialog", AgeSendaSyncActionController]);
	App.controller("ageSendaSyncDialogController", ["$scope", "$http", "$mdDialog", "$interval","$timeout",
		"$window", "pphhEnv","ageSendaService", AgeSendaSyncDialogController]);

	function AgeSendaSyncActionController($mdDialog) {
		this.performAction = performAction;


		function performAction(scope) {
			$mdDialog.show({
				clickOutsideToClose: false,
				escapeToClose: false,
				parent: angular.element(document.body), 
				controller: "ageSendaSyncDialogController",
				templateUrl: "/age/sendaSyncStatus-init"
			});
		}
	}

	function AgeSendaSyncDialogController($scope, $http, $mdDialog,$timeout, $interval, $window, pphhEnv,ageSendaService) {
		
		$scope.timer = undefined;
		$scope.filterResults = [];
		$scope.isLoading = false;
		$scope.isRunning = false;
		$scope.firstLoad = false;
		
		$scope.init = init;
		$scope.conectionList = conectionList;
		$scope.requestSync = requestSync;
		$scope.requestSyncStatus = requestSync;
		$scope.closeDialog = closeDialog;
		$scope.exportar = exportar;
		$scope.syncRunning =syncRunning; 
		
		function init() {
			requestSyncStatus();
			$scope.timer = $interval(requestSyncStatus, 30000);
		}

		function conectionList (){
			$scope.isLoading = true;
			ageSendaService.getConnections().then(
				function(response) {
					$scope.isLoading = false;
					$scope.firstLoad = true;
					$scope.filterResults = response.data;
					
				},
				function(reponse) {
					showGenericError("Error filter.");
					$scope.isLoading = false;
				}				
			);			
		}
		function requestSyncStatus() {
			conectionList();
			ageSendaService.getStatus ().then(
				function(response) {					
					$scope.isRunning = response.data[0].inProgress;	
				},
				function(reponse) {
					showGenericError("Error senda sync status");
					$scope.isRunning = false;
				}				
			);
		}

		function requestSync() {
			$scope.isRunning = true;
			var request = { 
				method: "POST",
				url: "/age/sendaSync",
				params: {
					
				}
			};
			request.headers = {};
			request.headers[_csrf_headerName] = _csrf_token;
			$http(request).then(
				function() {
					$timeout(requestSyncStatus, 1000);
					$scope.isRunning = true;
				}
				, function() {		
					conectionList ();		
					$scope.isRunning = false;
				});
		}

		function closeDialog() {
			if ($scope.timer != undefined) {
				$interval.cancel($scope.timer);
				$scope.timer= undefined;
			}
			$scope.timer = undefined;
			$mdDialog.hide();

		}
		function exportar(id) {
			var url = pphhEnv.global.contextPath + "/age/sendaErrorExport?conexion=" + id;
			$window.open(url);
		}
		function syncRunning(){
			return $scope.isRunning;
		}
		
		function showGenericError(message) {
			$mdDialog.show(
					$mdDialog.alert({
						title: UIMessages.dialog.confirm.title,
						textContent: "Error get",
						ok: UIMessages.dialog.confirm.cerrar,
						multiple: true
					}));
		}		

	}

})();